import { Injectable } from '@angular/core';

import { TransferState } from '@modules/transfer-state/transfer-state';
import { environment } from '@environments/environment';

export const browserAllowedEnvKeys = [
  'GIT_COMMIT_SHA',
  'VTR_API_URL',
  'VTR_RAVEN_PUBLIC_DSN',
  // don't specify the VTR_RAVEN_PUBLIC_DSN here - it must not be public
  'VTR_GTM_ID',
  'VTR_DOMAIN',
];

@Injectable()
export class RuntimeEnvironmentService {
  static STATE_KEY = 'CORE_RUNTIME_ENV';
  protected env: { [key: string]: string };

  constructor(protected transferState: TransferState) {
    this.initEnv();
  }

  get serverName() {
    // todo: maybe fingerprint the browser?
    // https://github.com/biggora/device-uuid
    return 'browser';
  }

  get gitCommitSha() {
    return this.env.GIT_COMMIT_SHA || 'dev';
  }

  /**
   * Returns API base URL, w/o trailing slash.
   */
  get apiUrl() {
    return this.env.VTR_API_URL.replace(/\/+$/, '');
  }

  get domain() {
    return this.env.VTR_DOMAIN;
  }

  get ravenDsn() {
    // browser - use public DSN
    return this.env.VTR_RAVEN_PUBLIC_DSN;
  }

  get googleTagManagerId() {
    return this.env.VTR_GTM_ID;
  }

  protected initEnv() {
    this.env = { ...(environment as any).runtimeEnvironment }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/runtime-environment.service.ts